import { Component } from '@angular/core';
import {
    ParametersService,
    SubtitlesService,
    ZonesService,
    ZonesSystemService
} from "../../core";
import {StateService} from "@uirouter/core";

@Component({
    selector: 'opentherm-card',
    templateUrl: './opentherm-card.component.html',
    styleUrls: ['./opentherm-card.component.scss']
})
export class OpenthermCardComponent {
    constructor(
        private parameters: ParametersService,
        private $state: StateService,
        private subtitles: SubtitlesService,
        public zones: ZonesService,
        public zonesSystem: ZonesSystemService,
    ) {
    }

    subtitle(id: number) {
        return this.subtitles.setSubtitle(id);
    }

    ngOnInit() {
        if (this.zones.selectedZone === undefined) {
            this.$state.go('home', {selectedModuleHash: this.parameters.selectedModuleHash});
            return;
        }
        this.zones.setOverflow();
    }
}
